import i18n from 'Pods/Shared/I18n'
import threeDStudioTranslationsDE from 'Pods/ThreeDStudio/Locales/threeDStudioTranslationsDE.json'
import threeDStudioTranslationsEN from 'Pods/ThreeDStudio/Locales/threeDStudioTranslationsEN.json'
import threeDStudioTranslationsES from 'Pods/ThreeDStudio/Locales/threeDStudioTranslationsES.json'
import threeDStudioTranslationsFR from 'Pods/ThreeDStudio/Locales/threeDStudioTranslationsFR.json'
import threeDStudioTranslationsJP from 'Pods/ThreeDStudio/Locales/threeDStudioTranslationsJP.json'
import threeDStudioTranslationsPT from 'Pods/ThreeDStudio/Locales/threeDStudioTranslationsPT.json'
import threeDStudioTranslationsRU from 'Pods/ThreeDStudio/Locales/threeDStudioTranslationsRU.json'
import threeDStudioTranslationsZHCN from 'Pods/ThreeDStudio/Locales/threeDStudioTranslationsZHCN.json'

// Add the three-d-studio namespace to the existing i18n instance
i18n.addResourceBundle('en', 'three-d-studio', threeDStudioTranslationsEN, true, true)
i18n.addResourceBundle('de', 'three-d-studio', threeDStudioTranslationsDE, true, true)
i18n.addResourceBundle('es', 'three-d-studio', threeDStudioTranslationsES, true, true)
i18n.addResourceBundle('fr', 'three-d-studio', threeDStudioTranslationsFR, true, true)
i18n.addResourceBundle('ja', 'three-d-studio', threeDStudioTranslationsJP, true, true)
i18n.addResourceBundle('pt', 'three-d-studio', threeDStudioTranslationsPT, true, true)
i18n.addResourceBundle('ru', 'three-d-studio', threeDStudioTranslationsRU, true, true)
i18n.addResourceBundle('zh-CN', 'three-d-studio', threeDStudioTranslationsZHCN, true, true)

export default i18n
